module.exports = __webpack_public_path__ + "img/banner@2x.6b450174.png";